<script lang="ts">
  import { _ } from 'svelte-i18n';
  import { withUnit, changeWithUnit } from './format';

  /* eslint-disable @typescript-eslint/no-explicit-any */
  // How far from the start the athlete got toward each target: one bar per measure, from the start (left) to the target (right).
  export let rows: { label: string; unit: string; start: number | null; finish: number | null; target: number }[] = [];
  export let finishLabel: string | null = null;

  const share = (r: any): number | null => {
    if (r.start === null || r.finish === null) return null;
    if (r.target <= r.start) return r.finish >= r.target ? 1 : 0;
    return (r.finish - r.start) / (r.target - r.start);
  };
</script>

<div class="space-y-4">
  {#each rows as r}
    {@const f = share(r)}
    <div>
      <div class="flex justify-between text-sm"><span class="font-medium">{r.label}</span><span class="text-zinc-500 tabular-nums">{$_('report.progress.goal', { values: { value: withUnit(r.unit, r.target) } })}</span></div>
      <div class="relative h-2.5 rounded-full bg-zinc-100 mt-1.5">
        {#if f !== null}<div class="absolute inset-y-0 left-0 rounded-full {f >= 1 ? 'bg-green-500' : 'bg-blue-500'}" style="width: {Math.min(100, Math.max(0, f * 100))}%" />{/if}
        <!-- the target: the right end of the bar; a measure past it is shown as such below -->
        <div class="absolute -top-1 -bottom-1 right-0 w-0.5 bg-zinc-500" title={$_('report.progress.goal_title')} />
      </div>
      <div class="flex justify-between text-xs text-zinc-500 mt-1 tabular-nums">
        <span>{$_('report.overview.start')}<br /><span class="text-sm text-zinc-800">{withUnit(r.unit, r.start)}</span></span>
        <span class="text-right">{finishLabel ?? $_('report.overview.achieved')}<br /><span class="text-sm text-zinc-800">{withUnit(r.unit, r.finish)}</span>{#if f !== null && f > 1.0005}<span class="text-green-700"> · {$_('report.progress.of_the_way', { values: { percent: Math.round(f * 100) } })}</span>{/if}{#if r.start !== null && r.finish !== null}<br /><span class={r.finish - r.start >= 0 ? 'text-green-600' : 'text-red-600'}>({changeWithUnit(r.unit, r.finish - r.start)}{r.start ? ` / ${r.finish - r.start >= 0 ? '+' : ''}${(Math.round(((r.finish - r.start) / Math.abs(r.start)) * 1000) / 10).toFixed(1)}%` : ''})</span>{/if}</span>
      </div>
    </div>
  {/each}
</div>
